import { render } from "./CardAdminList.vue?vue&type=template&id=ac253be2"
import script from "./CardAdminList.vue?vue&type=script&lang=js"
export * from "./CardAdminList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__